"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
function encodeSemicolon(str) {
    return str.replace(/;/g, '%3b');
}
function getSoundCloudUrl(url, _a) {
    var showAtWork = _a.showAtWork;
    // if URL includes 2 characters of '?'
    // for example: "https://w.soundcloud.com/player/?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F68403644?"
    var urlInstance = new URL(url);
    var questionMarkPosition = urlInstance.search.indexOf('?', 1);
    if (questionMarkPosition > 0) {
        urlInstance.search = urlInstance.search.substr(0, questionMarkPosition);
    }
    // Copied from the legacy component implementation:
    // Checks for true in either boolean or text values. This is done because
    // when setting the data from the panel, i get actual boolean values.
    // When setting the panel via the server, i get string values.
    var validShowAtWork = typeof showAtWork !== 'undefined' ? '' + showAtWork : 'true';
    urlInstance.searchParams.set('visual', validShowAtWork);
    // remove color url param which defects autoplay
    urlInstance.searchParams.delete('color');
    return urlInstance.href;
}
exports.props = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    var soundCloudUrl = '';
    var url = compData.url, showAtWork = compData.showAtWork, autoPlay = compData.autoPlay;
    if (url) {
        soundCloudUrl = getSoundCloudUrl(url, { showAtWork: showAtWork });
        soundCloudUrl = decodeURIComponent(soundCloudUrl);
        soundCloudUrl = encodeSemicolon(soundCloudUrl);
    }
    return { url: soundCloudUrl, autoPlay: autoPlay };
});
exports.css = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    var isValidUrl = compData.url && compData.url.length > 0;
    return {
        '--display-placeholder-var': isValidUrl ? 'none' : 'block',
        '--display-iframe-var': isValidUrl ? 'block' : 'none',
    };
});
//# sourceMappingURL=SoundCloudWidget.js.map